import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const API_URL = process.env.NODE_ENV === 'production' ? process.env.REACT_APP_PROD_BACKEND + "cookbook/" : process.env.REACT_APP_DEV_BACKEND + "cookbook/";

export const cookbookApi = createApi({
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers) => {
            const user = JSON.parse(localStorage.getItem("user"));
            if (user && user.accessToken) {
                headers.set("authorization", user.accessToken);
            }
            return headers;
        },
    }),
    reducerPath: "cookbookApi",
    tagTypes: ["Entries", "Entry"],
    endpoints: (build) => ({
        getEntries: build.query({
            query: (q) => ({
                url: "",
                params: q ? { q } : {},
            }),
            providesTags: ["Entries"],
        }),
        getEntry: build.query({
            query: (id) => id,
            providesTags: (result, error, id) => [{ type: "Entry", id }],
        }),
        addEntry: build.mutation({
            query: ({ title, category, content }) => ({
                url: "",
                method: "POST",
                body: { title, category, content },
            }),
            invalidatesTags: ["Entries"],
        }),
        updateEntry: build.mutation({
            query: ({ id, title, category, content }) => ({
                url: id,
                method: "PUT",
                body: { title, category, content },
            }),
            invalidatesTags: (result, error, { id }) => ["Entries", { type: "Entry", id }],
        }),
        deleteEntry: build.mutation({
            query: (id) => ({
                url: id,
                method: "DELETE",
            }),
            invalidatesTags: ["Entries"],
        }),
    })
})

export const {
    useGetEntriesQuery,
    useGetEntryQuery,
    useAddEntryMutation,
    useUpdateEntryMutation,
    useDeleteEntryMutation,
} = cookbookApi;
